import React from "react";
import ReactDOM from "react-dom/client";
import "react-phone-number-input/style.css";
import { App } from "./app";
import "./index.css";
import "./desktop.css";
import { YMInitializer } from "react-yandex-metrika";
import { PostHogProvider } from "posthog-js/react";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={`phc_zXy6eJ3mR0pmC5YdaFQGmatM0MKh0C7qfgzOtczhoOs`}
      options={{
        api_host: `https://us.i.posthog.com`,
        defaults: "2025-05-24",
        capture_exceptions: true,
        debug: import.meta.env.MODE === "development",
      }}
    >
      <YMInitializer accounts={[98839886]} />
      <App />
    </PostHogProvider>
  </React.StrictMode>,
);
